import Meditation16 from './Meditation16'

export default Meditation16
